import React, { Component } from 'react'
import { CSVReader } from 'react-papaparse'
import Button from "@material-ui/core/Button";

const buttonRef = React.createRef()

export default class CSVReader1 extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.onFileLoadFunc = props.onFileLoadFunc ? props.onFileLoadFunc : this.handleOnFileLoad;
        this.onFileLoadErrorFunc = props.onFileLoadErrorFunc ? props.onFileLoadErrorFunc : this.handleOnError;
    }

    handleOpenDialog = (e) => {
        // Note that the ref is set async, so it might be null at some point
        if (buttonRef.current) {
            buttonRef.current.open(e)
        }
    }

    handleOnFileLoad = (data) => {
        console.log('---------------------------')
        console.log(data)
        console.log('---------------------------')
    }

    handleOnError = (err, file, inputElem, reason) => {
        console.log(err)
    }

    handleOnRemoveFile = (data) => {
        console.log('---------------------------')
        console.log(data)
        console.log('---------------------------')
    }

    handleRemoveFile = (e) => {
        // Note that the ref is set async, so it might be null at some point
        if (buttonRef.current) {
            buttonRef.current.removeFile(e)
        }
    }

    render() {
        return (
            <>
                <CSVReader
                    ref={buttonRef}
                    onFileLoad={this.onFileLoadFunc}
                    onError={this.onFileLoadErrorFunc}
                    noClick
                    noDrag
                    config={{header: true}}
                    onRemoveFile={this.handleOnRemoveFile}
                >
                    {({ file }) => (
                        <aside
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                marginBottom: 10
                            }}
                        >
                            <Button size="small" color="primary" onClick={this.handleOpenDialog}>
                                Import CSV File
                            </Button>
                        </aside>
                    )}
                </CSVReader>
            </>
        )
    }
}